module.exports = __webpack_public_path__ + "img/adobe-acrobat-pdf-file-512.98a837f1.png";